<template>
  <v-card class="ma-0 pa-0">
    <v-card class="d-flex justify-center align-center">
      <div>
        <v-tabs v-model="currentTab">
          <v-tab>Buscar</v-tab>
          <v-tab>Agregar AFIP</v-tab>
          <v-tab v-show="enableManual === true">Agregar Manual</v-tab>
        </v-tabs>
      </div>
    </v-card>

    <paginated-search-table
      v-show="currentTab === 0"
      endpoint="/data/persons"
      ordering="name"
      searchLabel="Nombre/CUIT"
      :headers="tableHeaders"
      @itemSelected="onItemSelected($event)"
    >
    </paginated-search-table>

    <person-tax-record
      v-show="currentTab === 1"
      @save="save($event)"
    ></person-tax-record>

    <person-manual
      v-show="currentTab === 2 && enableManual"
      @save="save($event)"
    ></person-manual>
  </v-card>
</template>
<script>
import PaginatedSearchTable from "@/components/PaginatedSearchTable.vue";
import PersonTaxRecord from "@/components/PersonTaxRecord.vue";
import PersonManual from "@/components/PersonManual.vue";

export default {
  name: "Person",
  props: {
    enableManual: {
      type: Boolean,
      default: false
    }
  },

  components: {
    PaginatedSearchTable,
    PersonTaxRecord,
    PersonManual
  },

  data: () => ({
    currentTab: 0,
    currentItem: null,
    tableHeaders: [
      { text: "Nombre", value: "name", sortable: false },
      { text: "CUIT", value: "identification", sortable: false },
      { text: "Domicilio", value: "fiscal_address", sortable: false },
      { text: "CP", value: "fiscal_zipcode", sortable: false },
      { text: "Localidad", value: "fiscal_locality", sortable: false },
      { text: "Provincia", value: "fiscal_province", sortable: false }
    ]
  }),

  methods: {
    async save(args) {
      try {
        //validate new person information
        if (this.$bRoot.isNullOrEmpty(args, "name")) {
          throw "El dato nombre es obligatorio";
        }
        if (this.$bRoot.isNullOrEmpty(args, "identification")) {
          throw "El dato número de documento es obligatorio";
        }
        if (
          this.$bRoot.isNullOrEmpty(args, "identification_type") ||
          this.$bRoot.isNullOrEmpty(args, "identification_type_code")
        ) {
          throw "El dato tipo de documento es obligatorio";
        }
        if (args.identification.toString().match(/\D/) != null) {
          throw "El número de documento no puede contener caracteres no numéricos";
        }
        if (args.identification.toString().length != 11) {
          throw "El número de documento debe contener once dígitos";
        }

        let newPerson = {
          name: args.name,
          identification: args.identification,
          identification_type: args.identification_type,
          fiscal_address: args.fiscal_address,
          fiscal_locality: args.fiscal_locality,
          fiscal_province: args.fiscal_province,
          fiscal_zip_code: args.fiscal_zip_code
        };

        let response = await this.$bRoot.add(
          "/data/extended_persons",
          "identification_type__code=" +
            args.identification_type_code +
            "&identification=" +
            args.identification.toString(),
          newPerson
        );

        if (response) {
          this.$emit("itemSelected", response);
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      }
    },

    onItemSelected(args) {
      this.$emit("itemSelected", args);
    }
  },

  mounthed() {
    //
  }
};
</script>
